/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TAA } from './tAA';

/**
 * All relevant input data for creation of a temporary order.
 */
export interface GetOrderRequest {
  order: TAA;
  documentRequest?: string;
}
